import { Row, Col, Badge } from 'reactstrap';
import { PageHeader } from '../../components/PageHeader';
import { DataTable } from '../../components/DataTable';
import { KpiCard } from '../../components/KpiCard';
import { useComplianceStats } from './useComplianceStats';

/**
 * Produkt-Statistik Compliance — Betreiber-Sicht, nur lesend. KPI-Kacheln oben,
 * darunter die Aufschlüsselung der Runs nach Verdikt.
 */
const fmt = new Intl.NumberFormat('de-DE');

function verdictBadge(verdict) {
  if (verdict === 'ok') return <Badge color="success">ok</Badge>;
  if (verdict === 'issues') return <Badge color="warning">issues</Badge>;
  return <Badge color="secondary">{verdict}</Badge>;
}

export function NexusComplianceStatsPage() {
  const stats = useComplianceStats();
  const data = stats.data ?? {};
  const byVerdict = data.byVerdict ?? [];
  const avgScore = data.avgScore == null ? '—' : fmt.format(data.avgScore);

  return (
    <div>
      <PageHeader title="Compliance" subtitle="Produkt-Statistik — Monitore, Runs und Verdikte" />

      <Row className="g-3 mb-3">
        <Col xs="6" md="4" lg="2"><KpiCard label="Monitore" value={fmt.format(data.monitors ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="davon aktiv" value={fmt.format(data.enabled ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="Tenants" value={fmt.format(data.tenants ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="Runs" value={fmt.format(data.runs ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="Ø-Score" value={avgScore} /></Col>
      </Row>

      <Row className="g-3">
        <Col xs={12} lg={6}>
          <div className="text-muted small text-uppercase mb-2">Runs nach Verdikt</div>
          <DataTable
            loading={stats.isLoading}
            error={stats.error}
            empty={!stats.isLoading && byVerdict.length === 0}
            emptyMessage="Keine Verdikt-Daten."
            onRetry={() => stats.refetch()}
          >
            <thead>
              <tr>
                <th>Verdikt</th>
                <th className="text-end">Runs</th>
              </tr>
            </thead>
            <tbody>
              {byVerdict.map((r) => (
                <tr key={r.verdict}>
                  <td>{verdictBadge(r.verdict)}</td>
                  <td className="text-end small">{fmt.format(r.n ?? 0)}</td>
                </tr>
              ))}
            </tbody>
          </DataTable>
        </Col>
      </Row>
    </div>
  );
}
